export default {
  init() {
    // JavaScript to be fired on all pages

    //CONDENSED HEADER ON SCROLL
    let lastScroll = 0;
    // $('body').addClass('body-is-scrolled');
    $(window).scroll(function(){
     setTimeout(function() { //give them a second to finish scrolling before doing a check
       let scroll = $(window).scrollTop();
       if (scroll > lastScroll + 20) {
         $('body').addClass('going-down');
       } else if (scroll < lastScroll - 20) {
         $('body').removeClass('going-down');
       }
       lastScroll = scroll;
     }, 1000);
    });

    //SOLID FIXED MENU
    $(window).scroll(function () {
     let scroll = $(window).scrollTop();

     if (scroll >= 20) {
       $('body').addClass('scrolled');
     } else {
       $('body').removeClass('scrolled');
     }
    });

    $('.js-menu-open').click(function(e){
      e.preventDefault();
      $('.menu-overlay').toggleClass('activated');
      $(this).toggleClass('activated');
      $('.menu-block-right').toggleClass('active')
      // $('body').toggleClass('activated-nav-side left'); // add left class
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js